module.exports = __webpack_public_path__ + "static/media/light-snapchat-icon.01069758.svg";